import { callApi } from "../../../../global/js/api";
import * as dataLayer from "../../../../global/js/dataLayer";
import { QuantityInput, updateQuantity } from "../../../widgets/quantityInput/js/quantityInput";
import { ShoppingCartItem } from "../../../widgets/shoppingCartItem/js/shoppingCartItem";

// CONSTANTS are all caps.
const NS = 'PromotionalList';
const CLS = 'promotionalList';
const BLK = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out ./loadBlk.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'

export class PromotionalList {

	constructor($el) {
		this.$el = $el;
		this.$queryBlock = $(this.$el);
	}

	init() {
		this.registerEvent();
	}

	actionAnimation() {
		this.$queryBlock.find('[data-progress]').each((index, $element) => {
			$element.style.width = `${$element.dataset.progress}%`
		});
	}

	registerEvent() {
		$(document).on('promotional.update', (event, promotionalList, lineItemPrices) => {
			this.updateShoppingCartItems(lineItemPrices);
			this.updatePromotionItems(promotionalList);
		});

		this.$queryBlock.on('click', '[data-add-promotion]', (event) => {
			const $addToCart = event.currentTarget;
			const {
				code,
				quantity,
				addPromotion: endpoint
			} = $addToCart.dataset;
			const reload = () => window.location.reload();
			$('.loading-spinner').addClass('is-active');

			this.addPromotionItem({
				endpoint,
				code,
				quantity,
			}, reload, reload);
		});
	}

	updatePromotionItems(promotionalList) {
		this.$queryBlock.html((promotionalList || []).map((promotionalItem) => {
			return this.renderPromotionItem(promotionalItem);
		}));
		setTimeout(() => {
			this.actionAnimation();
		}, 100);
	}

	updateShoppingCartItems(lineItemPrices) {
		const ids = $('[data-wg="ShoppingCartItem"]').toArray().map(($element) => `${$element.dataset.id}`);
		const shoppingCartItems = lineItemPrices.filter(({ id }) => !ids.includes(`${id}`));
		const deletedIds = ids.filter((id) => !lineItemPrices.map(({ id }) => `${id}`).includes(`${id}`));

		deletedIds.map((id) => {
			$(`.shoppingCartItem[data-id="${id}"]`).remove();
		});

		$('.list-product:not(.promotionalList)').append(shoppingCartItems.map((item) => {
			const $item = this.renderLineItemPrice(item);
			(new QuantityInput($item.find('.quantityInput'))).init();
			(new ShoppingCartItem($item[0])).init();

			return $item;
		}));

		const lineItem = (lineItemPrices || []).reduce((acc, cur) => {
			acc[cur.id] = cur;
			return acc;
		}, {});

		$('[check-hide-remove-button]').each((index, element) => {
			const id = element.dataset.id;
			if (lineItem[id]) {
				const $quantity = $(element).find('.quantityInput');
				if (lineItem[id].shouldHideRemoveButton) {
					$(element).addClass('is-hide-remove-button');
					updateQuantity($quantity, { remove: false, quantity: lineItem[id].quantity});
				} else {
					$(element).removeClass('is-hide-remove-button');
					updateQuantity($quantity, { remove: true, quantity: lineItem[id].quantity});
				}
			}
		});
	}

	renderPromotionItem({
		BadgeBackgroundColor,
		BadgeName,
		BadgeTextColor,
		Details,
		Header,
		IsRedeemed,
		HasDiscountedItemInCart,
		IsFreeGiftDiscount,
		MissingAmount,
		ProductImage,
		ProductPrice,
		ProductUrl,
		Progress,
		RequiredAmount,
		TandCUrl,
		VariationCode
	}) {
		const $beforeProgess = this.$queryBlock.find(`[data-progress-code="${VariationCode}"]`);
		const beforeProgessStyle = $beforeProgess[0] ? $($beforeProgess[0]).attr('style') : '';
		const cssAddedToCart = IsRedeemed && HasDiscountedItemInCart ? "is-added-to-cart" : "is-add-to-cart";
		const cssQualify = MissingAmount <= 0 ? "is-qualify" : "no-qualify";
		const cssFreeGiftDiscount = IsFreeGiftDiscount ? "is-free-gift" : "is-free-item";
		const cssClass = [cssAddedToCart, cssQualify, cssFreeGiftDiscount].join(' ');

		return $(`
		<div class="shoppingCartItem promotional-cart-item ${cssClass}">
			<div class="position-relative">
				<div class="shoppingCartItem-content d-flex">
					<div>
						<a href="${ProductUrl}" target="_blank">
							<img class="shoppingCartItem-img" src="${ProductImage}">
						</a>
					</div>
					<div class="shoppingCartItem-details">
						<div class="row">
							<div class="col-12 col-md-6 promotional-left">
								<div class="row">
									<div class="col-12">
										<div class="mr-2 ml-0 promotion-label productItem-label productItem-label--custom"
											style="background-color: ${BadgeBackgroundColor};color: ${BadgeTextColor}">
											${BadgeName}
										</div>
										<div class="mr-2 ml-0 promotion-label productItem-label productItem-label--custom d-free-gift"
											style="background-color: #929292; color: #ffffff">
											GIFTED VALUE AT ${ProductPrice}
										</div>
									</div>
									<div class="col-10">

									</div>
									<div class="col-12 justify-content-start">
										<div class="promotional-head-title">
											<span class="promotional-title">${Header}</span>
											<span class="promotional-rrp d-free-gift">RRP ${ProductPrice}</span>
										</div>
										<div class="promotional-content">
											${Details}
											<a href="${TandCUrl}" target="_blank">
												T's and C's Apply
											</a>
										</div>
									</div>
								</div>
							</div>
							<div class="col-12 col-md-6 promotional-right">
								<div class="row">
									<div class="col-8 col-lg-9" promotional-msg>
										<span class="d-added-to-cart">
											<span class="d-qualify"><b>You qualify!</b></span>
											<span class="d-no-qualify">You're only <b>$${MissingAmount}</b> away!</span>
										</span>
										<span class="d-add-to-cart">
											<span class="d-qualify"><b>You qualify!</b> <span class="d-free-gift">Add the gift to your cart</span></span>
											<span class="d-no-qualify">You're only <b>$${MissingAmount}</b> away!</span>
										</span>
									</div>
									<div class="col-4 col-lg-3">
										<span class="d-block text-right" promotional-price>$${RequiredAmount}</span>
									</div>
									<div class="col-12">
										<div class="promotion-progressbar">
											<div class="progress-state"
												style="${beforeProgessStyle}"
												data-progress-code="${VariationCode}"
												data-progress="${Progress}"></div>
										</div>
									</div>
									<div class="col-12 d-qualify">
										<button class="promotion-add-to-cart button-btn button--primary btn-block d-added-to-cart">
											<span class="icon-gift d-free-gift"></span>
											ADDED
										</button>
										<button class="promotion-add-to-cart button-btn button--primary btn-block d-add-to-cart"
											data-add-promotion="/api/cart/add-to-cart/"
											data-code="${VariationCode}"
											data-quantity="1">
											<span class="icon-gift d-free-gift"></span>
											<span class="d-free-gift">ADD FREE GIFT</span>
											<span class="d-free-item">ADD TO CART</span>
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="clearfix"></div>
				</div>
			</div>
		</div>`);
	}

	addPromotionItem(prop, succesCB, failCB) {
		const {
			code,
			quantity,
			endpoint
		} = prop;
		callApi(endpoint, { code, quantity }).then((data) => {
			if (data.result == 'SUCCESS') {
				const res = data.response;
				const productObj = {
					code: prop.code,
					quantity: prop.quantity,
					size: prop.size || '',
					items: prop.items || [],
				};
				dataLayer.pushAddToCart(productObj, prop.datalayerDataSource);
				if (res.cartItems) {
					let cartItems = res.cartItems;
					if (typeof cartItems === 'string') {
						cartItems = JSON.parse(cartItems);
					}

					dataLayer.pushCartItems(cartItems);
				}

				if (succesCB) succesCB(data);
			} else {
				if (failCB) failCB(data);
			}
		});
	}

	renderLineItemPrice({
        id,
		image,
		url,
		name,
		barcode,
		shouldHideRemoveButton,
		isClickCollectNotAvailable,
        quantity,
        extendedPrice,
		isAustralianVendor,
		isHeavy,
		isDropship,
		bonusBuyBadges,
		colourName,
		sizeDescription,
	}) {
		let htmlAuVendorText = '';
		let htmlClickCollectMessage = '';
		let htmlBonusBuyBadges = '';

		if (isAustralianVendor && isHeavy) {
			htmlAuVendorText = window.heavyAustralianVendorText;
		} else if (isAustralianVendor) {
			htmlAuVendorText = window.australianVendorText;
		}

		if (isClickCollectNotAvailable || isDropship) {
			htmlClickCollectMessage = `<div class="shoppingCartItem-clickCollectMessage">${ window.clickCollectNotAvailableMessage }</div>`;
		}

		if (bonusBuyBadges && bonusBuyBadges.length) {
			// Append html for call refreshBonusBuyBadge to update view.
			htmlBonusBuyBadges = `
			<br />
			<div class="bonus-buy-available">
				<b>Available Promotions:</b>
			</div>
			<div class="bonus-wrapper"></div>
			`;
		}

		return $(`<div new class="shoppingCartItem"
			check-hide-remove-button
			data-wg="ShoppingCartItem"
			data-prev-quantity=""
			data-id="${id}"
			data-remove-item-api-endpoint="/api/cart/remove-variation"
			data-update-item-api-endpoint="/api/cart/update-variation"
			data-get-stock-data-url="/api/check-out/stock-data">
			<div class="position-relative">
				<div class="error-messages"></div>
				<div class="shoppingCartItem-content d-flex"
					data-item-barcode="${barcode}"
					item-low-stock-threshold
					item-out-of-stock-threshold
					data-is-click-collect-not-available="${ isClickCollectNotAvailable ? 'True' : 'False' }">
					<div>
						<img class="shoppingCartItem-img" src="${image}">
					</div>
					<div class="shoppingCartItem-details">
						<div class="row">
							<div class="col-12 col-md-6">
								<a href="${url}" class="shoppingCartItem-itemName">
									<div class="shoppingCartItem-name">${name}</div>
									<div class="shoppingCartItem-itemPrice d-md-none font-weight-normal">
										<span>Unit price: </span>
										<span class="price"></span>
									</div>
									<div class="shoppingCartItem-stock"></div>
									${htmlClickCollectMessage}
									${colourName ? `<div class="shoppingCartItem-itemColour"><span>Colour: </span>${colourName}</div>` : ''}
									${sizeDescription ? `<div class="shoppingCartItem-itemSize"><span>Size: </span>${sizeDescription}</div>` : ''}
								</a>
								<div class="d-none d-md-block w-100">
									${htmlBonusBuyBadges}
								</div>
							</div>
							<div class="col-12 col-md-2 pr-0">
								<div class="shoppingCartItem-itemPrice d-none d-md-block">
									<div class="price"></div>
								</div>
							</div>
							<div class="col-12 col-md-2">
								<div class="shoppingCartItem-quantityInput">
									<div class="quantityInput" remove-zero="true">
										<input type="number" class="form-control" min="1" value="${quantity}" step="1">
										<div class="quantityInput-down btn-down">
											<span class="icon-minus"></span>
										</div>
										<div class="quantityInput-up btn-up">
											<span class="icon-plus"></span>
										</div>
									</div>
								</div>
							</div>
							<div class="col-12 col-md-2">
								<div class="shoppingCartItem-total highlight">
									<span class="itemSubTotal item-total">$${extendedPrice}</span>
								</div>
							</div>
						</div>
					</div>
					<div class="clearfix"></div>
				</div>
				<div role="button" type="button" class="shoppingCartItem-removeBtn item-remove-btn">Remove</div>
				<div class="d-md-none">
					${htmlBonusBuyBadges}
				</div>
				<div class="shoppingCartItem-removeOverlay remove-item-overlay">
					<div class="shoppingCartItem-confirmText">Are you sure you want to remove this item?</div>
					<div class="shoppingCartItem-confirmationBtns">
						<button type="button" class="button-btn button--btnOutline-black cancel-button">Cancel</button>
						<button type="button" class="button-btn button--primary remove-confirm">Remove</button>
					</div>
				</div>
			</div>
		</div>`);
	}
}

export function updatePomotional(freeOrDiscountedPromotionalItems, lineItemPrices = []) {
	$(document).trigger('promotional.update', [freeOrDiscountedPromotionalItems, lineItemPrices]);
}



// WEBPACK FOOTER //
// D:/AzureDevops/vsts-agent-win-x64-2.202.1_06/_work/151/s/FrontEnd/src/views/blocks/promotionalList/js/promotionalList.js